import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import { CurrencyPipe, APP_BASE_HREF, TitleCasePipe } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay
} from '@angular/platform-browser';
import { UrlSerializer } from '@angular/router';
import { TrailingSlashUrlSerializer } from '@core/trailing-slash-url.serializer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { appRouterProviders } from './app-routing.module';
import { errorInterceptor } from './core/error.interceptor';
import { zoneHttpInterceptor } from './core/zone-http.interceptor';
import { HttpService } from './core/http.service';
import { NgxStripeModule } from 'ngx-stripe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { provideStore } from '@ngrx/store';
import { UserProfileReducer } from './modules/shared/user-profile.reducer';
import { cacheReducer } from './modules/shared/store/cache.reducer';
import { apiCacheReducer } from './core/cache/api-cache.reducer';
import { provideSharedRootProviders } from './modules/shared/shared-root.providers';
import { authInterceptor } from './core/auth-int.interceptor';
import { HistoryService } from './core/routing-history.service';
import { provideServiceWorker } from '@angular/service-worker';
import { WINDOW, windowProvider } from './core/window.token';
import { CacheService } from '@shared/services/cache.service';
import { initializeRuntimeWlsConfig } from '@utils/common.utils';
import { providePrimeNG } from 'primeng/config';
import * as LaraTheme from '@primeuix/themes/lara';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSharedRootProviders(),
    {
      provide: APP_INITIALIZER,
      useFactory: () => initializeRuntimeWlsConfig,
      multi: true
    },
    // Angular 21 bootstraps zoneless by default. Keep zone CD here so
    // client and SSR share it.
    provideZoneChangeDetection(),
    provideHttpClient(
      withFetch(),
      withInterceptors([errorInterceptor, authInterceptor, zoneHttpInterceptor])
    ),
    provideClientHydration(withEventReplay()),
    ...appRouterProviders,
    providePrimeNG({
      theme: {
        preset: LaraTheme.default,
        options: {
          darkModeSelector: 'none'
        }
      }
    }),
    provideStore(
      {
        userProfile: UserProfileReducer,
        refreshKeys: UserProfileReducer,
        otherUserProfile: UserProfileReducer,
        cache: cacheReducer,
        apiCache: apiCacheReducer
      },
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false
        }
      }
    ),
    importProvidersFrom(
      ModalModule,
      ToastrModule.forRoot(environment.toastrConfig),
      NgxStripeModule.forRoot(environment.stripeConfig.key)
    ),
    provideServiceWorker('offline.service.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    HttpService,
    NgbActiveModal,
    windowProvider,
    { provide: WINDOW, useExisting: WINDOW },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    CurrencyPipe,
    TitleCasePipe,
    HistoryService,
    CacheService
  ]
};
